import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getFaqPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/#otazky-odpovedi",
	});
}
